module.exports = __webpack_public_path__ + "img/express-delivery2.4d0f39a.svg";